
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>Complaints Policy</h1>
<hr>
<p>At Anymate, we value user feedback and strive to address any concerns or complaints promptly and effectively. This Complaints Policy outlines the procedures for users to report and resolve issues related to our services.</p>
<h2>Submitting a Complaint:</h2>
<ol>
<li>Complaints can be submitted through our Discord available on the Contact Us page.</li>
<li>Complaints can also be sent via email to <a href="mailto:support@any-mate.com">support@any-mate.com</a>.</li>
</ol>
<h2>Information Required:</h2>
<ol>
<li>Detailed description of the complaint.</li>
<li>Any supporting evidence or documentation.</li>
<li>Contact information for follow-up.</li>
</ol>
<h2>Acknowledgment:</h2>
<ol>
<li>Upon receipt of a complaint, we will acknowledge the complaint within 24 hours.</li>
</ol>
<h2>Confidentiality:</h2>
<ol>
<li>All complaints and related information will be handled with strict confidentiality.</li>
<li>All reported complaints will be reviewed and resolved within 7 business days.
For any questions or concerns regarding this policy, please contact us at <a href="mailto:support@any-mate.com">support@any-mate.com</a>.</li>
</ol>
</div>
</template>
